import { InvitationService } from "@/services/invitation/invitation.service";
const _invitationService = new InvitationService();

const setInvitationsAction = (
  { commit },
  { spaceId, page, callback, callbackError }
) => {
  _invitationService
    .getPendingInvitation(spaceId, page)
    .then((response) => {
      commit("setInvitations", response.data);
      callback(response);
    })
    .catch((error) => {
      callbackError(error);
    });
};
const increaseInvitationAction = (
  { commit, state },
  { invitationId, callback }
) => {
  _invitationService
    .increaseInvitation(invitationId)
    .then((response) => {
      if (!response.data.status) {
        const index = state.invitations.findIndex(
          (a) => a.id == response.data.id
        );
        state.invitations.splice(index, 1, response.data);
      }
      callback(response);
    })
    .catch((error) => console.log(error));
};

const removeInvitationAction = (
  { commit, state },
  { invitationId, callback }
) => {
  _invitationService
    .deleteInvitation(invitationId)
    .then((response) => {
      const index = state.invitations.findIndex((a) => a.id === invitationId);
      state.invitations.splice(index, 1);
      callback(response);
    })
    .catch((error) => console.log(error));
};
const deleteInvitationsAction = ({ commit }) => {
  commit("deleteInvitations");
};

export default {
  setInvitationsAction,
  deleteInvitationsAction,
  increaseInvitationAction,
  removeInvitationAction,
};
